<template>
  <Teleport to="body">
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content report-edit-modal"
      overlay-class="vfm__overlay" :click-to-close="true" :lock-scroll="true" :hide-overlay="false" :esc-to-close="true"
      @click:overlay="closeModal" @click="handleOutsideClick" @before-open="beforeOpen" @before-close="beforeClose">
      <div class="content p-3">
        <div v-if="dataSource && dataSource.plan">
          <div class="row" v-show="Object.keys(errors).length > 0">
            <div class="col-md-12">
              <div class="alert alert-warning">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <ul>
                  <li v-for="(error, fieldName) in errors" :key="fieldName">
                    {{ error }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <template v-if="dataSource.report">
            <p>担当者：{{ dataSource.report.staff.display_name }}</p>
            <p>報告時間：{{ dataSource.report.reported_at }}</p>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group row">
                  <label class="control-label">担当者</label>
                  <select-staff :office-id="dataSource.plan.office_id" :data-source="staffList" v-model="staff_id"
                    v-validate="'required'" style="width: 250px;" name="staff_id"
                    :class="{ 'has-danger': errors.staff_id }" data-vv-as="担当者" data-vv-validate-on="none"
                    @update:modelValue="val => staff_id = val" />
                </div>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-md-12">
              <label class="control-label">作業日時：</label>
              <div class="input-group">
                <div style="width: 170px" class="form-group" :class="{ 'has-danger': errors.start_day }">
                  <input class="form-control" type="date" v-model="start_day">
                  <input type="hidden" name="start_day" v-model="start_day" v-validate="'required'" data-vv-as="日付"
                    data-vv-validate-on="none">
                </div>
                <div style="width: 110px" class="form-group" :class="{ 'has-danger': errors.start_hhmm }">
                  <input class="form-control" type="time" name="start_hhmm" v-validate="'required'" v-model="start_hhmm"
                    data-vv-as="開始時刻" data-vv-validate-on="none">
                </div>
                <div style="line-height: 38px;">〜</div>
                <div style="width: 110px" class="form-group" :class="{ 'has-danger': errors.end_hhmm }">
                  <input class="form-control" type="time" name="end_hhmm" v-validate="'required'" v-model="end_hhmm"
                    data-vv-as="終了時刻" data-vv-validate-on="none">
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-2"
            v-if="dataSource.plan.service.service_type_id === 1180 || dataSource.plan.service.service_type_id === 1182">
            <div class="col-md-6">
              <label class="control-label">サービス：</label>
              <div class="input-group">
                <input class="form-control" type="text" maxlength="30" v-model="inputs.service_type_input">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="m-l-10 input-group">
                <input id="ownExpenseFlag" type="checkbox" v-model="inputs.ownExpenseFlag" :value="1" />
                <label for="ownExpenseFlag" class="font-14">自費サービス</label>
              </div>
            </div>
            <div class="col-md-4" v-if="isTaxi">
              <div class="m-l-10 input-group">
                <input id="wheelchairTaxiFlag" type="checkbox" v-model="inputs.wheelchairTaxiFlag" :value="1" />
                <label for="wheelchairTaxiFlag" class="font-14">車いすタクシー</label>
              </div>
            </div>
          </div>
          <div class="row p-b-10" v-if="isTaxi">
            <div class="col-md-3">
              <label class="control-label p-t-10">メーター料金</label>
              <div class="input-group">
                <input type="number" class="form-control text-right" maxlength="6" v-model="fare"
                  v-validate="'numeric|max_value:999999'" name="service.fare" :class="{ 'has-danger': errors.fare }"
                  data-vv-as="メーター料金" data-vv-validate-on="none" />
                <div class="input-group-append">
                  <span class="input-group-text">円</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label class="control-label p-t-10">支払：現金</label>
              <div class="input-group">
                <input type="number" class="form-control text-right" maxlength="6" v-model="payment_cach"
                  v-validate="'numeric|max_value:999999'" name="service.payment_cach"
                  :class="{ 'has-danger': errors.payment_cach }" data-vv-as="支払：現金"
                  data-vv-validate-on="none" />
                <div class="input-group-append">
                  <span class="input-group-text">円</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label class="control-label p-t-10">支払：未収</label>
              <div class="input-group">
                <input type="number" class="form-control text-right" maxlength="6" v-model="payment_unpaid"
                  v-validate="'numeric|max_value:999999'" name="service.payment_unpaid"
                  :class="{ 'has-danger': errors.payment_unpaid }" data-vv-as="支払：引き落とし(未収納)"
                  data-vv-validate-on="none" />
                <div class="input-group-append">
                  <span class="input-group-text">円</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label class="control-label p-t-10">支払：チケット</label>
              <div class="input-group">
                <input type="number" class="form-control text-right" maxlength="6" v-model="payment_ticket"
                  v-validate="'numeric|max_value:999999'" name="service.payment_ticket"
                  :class="{ 'has-danger': errors.payment_ticket }" data-vv-as="支払：チケット"
                  data-vv-validate-on="none" />
                <div class="input-group-append">
                  <span class="input-group-text">円</span>
                </div>
              </div>
            </div>
          </div>
          <div class="p-t-5">
            <select-care-items :service-type-id="dataSource.plan.service.service_type_id"
              v-model="inputs.service_items" />
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="control-label p-t-10">行き先</label>
              <input type="text" class="form-control" maxlength="60" v-model="destination" v-validate="'max:60'"
                name="service.destination" :class="{ 'has-danger': errors.destination }" data-vv-as="行き先"
                data-vv-validate-on="none" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label class="control-label p-t-10">預り金</label>
              <div class="input-group">
                <input type="number" class="form-control text-right" maxlength="30" v-model="deposit"
                  v-validate="'numeric'" name="service.deposit" :class="{ 'has-danger': errors.deposit }"
                  data-vv-as="預り金" data-vv-validate-on="none" />
                <div class="input-group-append">
                  <span class="input-group-text">円</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label class="control-label p-t-10">買物</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">-</span>
                </div>
                <input type="number" class="form-control text-right" maxlength="30" v-model="spending"
                  v-validate="'numeric'" name="service.spending" :class="{ 'has-danger': errors.spending }"
                  data-vv-as="預り金" data-vv-validate-on="none" />
                <div class="input-group-append">
                  <span class="input-group-text">円</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label class="control-label p-t-10">おつり</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">=</span>
                </div>
                <input type="text" readonly class="form-control text-right" :value="change">
                <div class="input-group-append">
                  <span class="input-group-text">円</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="control-label p-t-10">申し送り(100文字制限)</label>
              <textarea class="form-control" rows="5" v-model="inputs.takeover_comment"
                @input="assertMaxChars()"></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <a href="#" @click="close()">キャンセル</a>
            <span class="mx-2"></span>
            <button type="button" class="action-button btn btn-danger btn-rounded" @click.prevent="remove"
              :disabled="isProcessing" v-if="dataSource.report">
              削除する
            </button>
            <span class="mx-2"></span>
            <button type="button" class="action-button btn btn-rounded btn-success" @click="save"
              :disabled="isProcessing">保存する
            </button>
            <template v-if="dataSource.report">

            </template>
          </div>
        </div>
      </div>
      <div class="form-actions actions">
      </div>
      <BModal v-model="isShowConfirmDialog" title="確認" @ok="destroy" ok-title="はい" cancel-title="キャンセル" ok-variant="danger" no-fade="true">
        <p>削除してもよろしいですか？</p>
        <p>※削除した内容は復元できません。</p>
      </BModal>
    </vue-final-modal>
    <vue-final-modal v-if="isShowErrorDialog" v-model="isShowErrorDialog" classes="modal-overlay" >
      <div class="error-dialog">
        <div class="dialog-content">
          <div class="dialog-c-title">入力エラー</div>
          <div class="dialog-c-text">入力内容に誤りがあります。</div>
        </div>
        <div class="vue-dialog-buttons">
          <button type="button" @click="closeErrorDialog" class="vue-dialog-button" style="flex: 1 1 100%;">
            閉じる
          </button>
        </div>
      </div>
    </vue-final-modal>
  </Teleport>
</template>

<script setup>
import _ from 'underscore'
import Constants from '@/constants'
import utils from '@/libs/Utils'
import api from '@/libs/Api'
import SelectCareItems from '@/components/SelectCareItems.vue'
import SelectStaff from '@/components/SelectStaff.vue'
import { useStore } from 'vuex'
import { ref, computed } from 'vue'
import { useExecutor } from '@/libs/Executor'
import { useForm, configure } from 'vee-validate'
import * as yup from 'yup'
import { VueFinalModal } from 'vue-final-modal'
import { BModal } from 'bootstrap-vue-next'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.css'

configure({
  validateOnBlur: false, // controls if `blur` events should trigger validation with `handleChange` handler
  validateOnChange: false, // controls if `change` events should trigger validation with `handleChange` handler
  validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
  validateOnModelUpdate: false // controls if `update:modelValue` events should trigger validation with `handleChange` handler
})

const { exec } = useExecutor()
const store = useStore()

const _convertReport2Inputs = (report) => {
  if (report) {
    return {
      staff_id: report.staff_id,
      takeover_comment: report.takeover_comment,
      start_day: utils.formatDay(report.service.start_day),
      start_hhmm: utils.formatHHMM(report.service.start_hhmm),
      end_hhmm: utils.formatHHMM(report.service.end_hhmm),
      service_type_input: report.service.service_type_input,
      ownExpenseFlag: report.service.own_expense_flag === 1,
      wheelchairTaxiFlag: report.service.wheelchair_taxi_flag,
      destination: report.service.destination,
      spending: report.service.spending,
      deposit: report.service.deposit,
      fare: report.service.fare,
      payment_cach: report.service.payment_cach,
      payment_ticket: report.service.payment_ticket,
      payment_unpaid: report.service.payment_unpaid,
      service_items: _.map(report.service.service_items, serviceItem => {
        return serviceItem.care_item_id
      })
    }
  } else {
    return {
      staff_id: null,
      takeover_comment: null,
      service_type_input: null,
      start_day: null,
      start_hhmm: null,
      end_hhmm: null,
      ownExpenseFlag: false,
      wheelchairTaxiFlag: false,
      deposit: null,
      spending: null,
      fare: null,
      payment_cach: null,
      payment_ticket: null,
      payment_unpaid: null,
      destination: null,
      service_items: []
    }
  }
}

const _convertPlan2Inputs = (plan) => {
  return {
    staff_id: null,
    takeover_comment: null,
    service_type_input: plan.service.service_type_input ?? null,
    start_day: utils.formatDay(plan.service.start_day),
    start_hhmm: utils.formatHHMM(plan.service.start_hhmm),
    end_hhmm: utils.formatHHMM(plan.service.end_hhmm),
    ownExpenseFlag: plan.service.own_expense_flag,
    wheelchairTaxiFlag: plan.service.wheelchair_taxi_flag,
    destination: plan.service.destination,
    spending: plan.service.spending,
    deposit: plan.service.deposit,
    fare: null,
    payment_cach: null,
    payment_ticket: null,
    payment_unpaid: null,
    service_items: _.map(plan.service.service_items, serviceItem => {
      return serviceItem.care_item_id
    })
  }
}

const __convertInputs2Report = (inputs) => {
  let report = {
    staff_id: inputs.staff_id,
    takeover_comment: inputs.takeover_comment,
    service: {
      service_type_input: inputs.service_type_input,
      start_day: inputs.start_day.replace(/-/g, ''),
      start_hhmm: inputs.start_hhmm.replace(':', ''),
      end_hhmm: inputs.end_hhmm.replace(':', ''),
      own_expense_flag: inputs.ownExpenseFlag,
      wheelchair_taxi_flag: inputs.wheelchairTaxiFlag,
      destination: inputs.destination,
      spending: inputs.spending,
      deposit: inputs.deposit,
      fare: inputs.fare,
      payment_cach: inputs.payment_cach,
      payment_ticket: inputs.payment_ticket,
      payment_unpaid: inputs.payment_unpaid,
      service_items: _.map(inputs.service_items, serviceItem => {
        return { care_item_id: serviceItem }
      })
    }
  }
  return report
}

const props = defineProps({
  name: String,
  plan: Object,
  report: Object,
  modelValue: {
    type: Boolean,
    default: false
  }
})

const showModal = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
  }
})

const emit = defineEmits(['close', 'update:modelValue', 'cancel'])

const profile = computed(() => {
  return store.state.session.profile
})
const isProcessing = ref(false)
const isTaxi = ref(false)
const isSakura = ref(false)
const isUpdated = ref(false)
const inputs = ref({
  staff_id: null,
  start_day: null,
  start_hhmm: null,
  end_hhmm: null,
  takeover_comment: null,
  ownExpenseFlag: false,
  wheelchairTaxiFlag: false,
  deposit: null,
  fare: null,
  payment_cach: null,
  payment_ticket: null,
  payment_unpaid: null,
  service_items: []
})
const dataSource = ref(null)

const maxLengthInComment = ref(100)
const isShowErrorDialog = ref(false)
const isShowConfirmDialog = ref(false)

const { handleSubmit, errors, defineField, setValues } = useForm({
  validationSchema: {
    staff_id: yup.string().label('担当者').required('${label}を入力してください。'),
    start_day: yup.string().label('作業日').required('${label}を入力してください。'),
    start_hhmm: yup.string().label('開始時刻').required('${label}を入力してください。'),
    end_hhmm: yup.string().label('終了時刻').required('${label}を入力してください。'),
    fare: yup.number()
      .notRequired()
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .label('メーター料金')
      .max(999999, 'The ${label} field must be ${max} or less.'),
    payment_cach: yup.number()
      .notRequired()
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .label('現金')
      .max(999999, 'The ${label} field must be ${max} or less.'),
    payment_unpaid: yup.number()
      .notRequired()
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .label('支払：引き落とし(未収納)')
      .max(999999, 'The ${label} field must be ${max} or less.'),
    payment_ticket: yup.number()
      .notRequired()
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .label('支払：チケット')
      .max(999999, 'The ${label} field must be ${max} or less.'),
    destination: yup.string()
      .notRequired()
      .label('行き先')
      .max(60, '${label} は ${max} 文字以内で入力してください。'),
    deposit: yup.number()
      .notRequired()
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .label('預り金'),
    spending: yup.number()
      .notRequired()
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .label('買物')
  }
})
// eslint-disable-next-line camelcase
const [staff_id] = defineField('staff_id')
// eslint-disable-next-line camelcase
const [start_day] = defineField('start_day')
// eslint-disable-next-line camelcase
const [start_hhmm] = defineField('start_hhmm')
// eslint-disable-next-line camelcase
const [end_hhmm] = defineField('end_hhmm')
const [fare] = defineField('fare')
// eslint-disable-next-line camelcase
const [payment_cach] = defineField('payment_cach')
// eslint-disable-next-line camelcase
const [payment_unpaid] = defineField('payment_unpaid')
// eslint-disable-next-line camelcase
const [payment_ticket] = defineField('payment_ticket')
const [destination] = defineField('destination')
const [deposit] = defineField('deposit')
const [spending] = defineField('spending')

const change = computed(() => {
  let depositValue = Number(deposit.value ?? 0)
  let spendingValue = Number(spending.value ?? 0)
  return depositValue - spendingValue
})

const staffList = computed(() => {
  return _.filter(dataSource.value.plan.staff, staff => {
    return !(_.find(dataSource.value.plan.reports, report => {
      return report.staff_id === staff.id
    }))
  })
})

const save = () => {
  handleSubmit(async (value, { setErrors }) => {
    exec(async () => {
      if (isProcessing.value) return
      isProcessing.value = true

      const newData = {
        staff_id: staff_id.value,
        start_day: start_day.value,
        start_hhmm: start_hhmm.value,
        end_hhmm: end_hhmm.value,
        takeover_comment: inputs.value.takeover_comment,
        service_type_input: inputs.value.service_type_input,
        ownExpenseFlag: inputs.value.ownExpenseFlag,
        wheelchairTaxiFlag: inputs.value.wheelchairTaxiFlag,
        deposit: deposit.value,
        fare: fare.value,
        payment_cach: payment_cach.value,
        payment_ticket: payment_ticket.value,
        payment_unpaid: payment_unpaid.value,
        service_items: inputs.value.service_items,
        destination: destination.value,
        spending: spending.value
      }

      const report = __convertInputs2Report(newData)

      if (dataSource.value.report) {
        report.id = dataSource.value.report.id
        const res = await api.updateReport(report)
        return Promise.resolve(res)
      } else {
        report.plan_id = dataSource.value.plan.id
        const ignoreDelete = true // ReportServiceでdeleteをさせない処理
        const res = await api.createReport(report, ignoreDelete)
        return Promise.resolve(res)
      }
    }, setErrors)
      .then((res) => {
        if (res === false) {
          isShowErrorDialog.value = true
          return
        }
        if (dataSource.value.report) {
          dataSource.value.report.service.own_expense_flag = res.service.own_expense_flag
          dataSource.value.report.service.wheelchair_taxi_flag = res.service.wheelchair_taxi_flag
          dataSource.value.report.service.destination = res.service.destination
          dataSource.value.report.service.deposit = res.service.deposit
          dataSource.value.report.service.spending = res.service.spending
          dataSource.value.report.service.service_type_input = res.service.service_type_input
          dataSource.value.report.service.fare = res.service.fare
          dataSource.value.report.service.payment_cach = res.service.payment_cach
          dataSource.value.report.service.payment_ticket = res.service.payment_ticket
          dataSource.value.report.service.payment_unpaid = res.service.payment_unpaid
          dataSource.value.report.takeover_comment = res.takeover_comment
          dataSource.value.report.service.service_items.length = 0
          _.each(res.service.service_items, function (serviceItem) {
            dataSource.value.report.service.service_items.push(serviceItem)
          })
        } else {
          dataSource.value.plan.reports.push(res)
        }
        isUpdated.value = true
        close()
        emit('close', isUpdated.value)
      })
      .catch(() => {
      })
      .finally(() => {
        isProcessing.value = false
      })
  }, (error) => {
    console.log(error)
    isShowErrorDialog.value = true
  })()
}

const closeErrorDialog = () => {
  isShowErrorDialog.value = false
}

const beforeOpen = (event) => {
  isTaxi.value = (profile.value.site.function_mask & Constants.FunctionMask.TAXI) === Constants.FunctionMask.TAXI
  isSakura.value = (profile.value.site.function_mask & Constants.FunctionMask.SAKURA) === Constants.FunctionMask.SAKURA
  console.info(profile.value)

  dataSource.value = null
  dataSource.value = {
    plan: props.plan,
    report: props.report
  }
  if (dataSource.value.report) {
    inputs.value = _convertReport2Inputs(dataSource.value.report)
    setValues(inputs.value)
  } else {
    inputs.value = _convertPlan2Inputs(dataSource.value.plan)
    setValues(inputs.value)
  }
}

const beforeClose = () => {
  emit('close', isUpdated.value)
}

const close = () => {
  emit('cancel')
  showModal.value = false
}

const closeModal = () => {
  showModal.value = false
  emit('update:modelValue', false)
  emit('close', isUpdated.value)
}

const handleOutsideClick = (event) => {
  if (event.target.classList.contains('vfm__overlay')) {
    closeModal()
  }
}

const assertMaxChars = () => {
  if (!isSakura.value) return
  if (inputs.value.takeover_comment.length >= maxLengthInComment.value) {
    inputs.value.takeover_comment = inputs.value.takeover_comment.substring(0, maxLengthInComment.value)
  }
}

const remove = () => {
  isShowConfirmDialog.value = true
}

const destroy = () => {
  exec(async () => {
    if (isProcessing.value) return
    isProcessing.value = true
    await api.deleteReport(dataSource.value.report.id)
    const index = _.indexOf(dataSource.value.plan.reports, dataSource.value.report)
    dataSource.value.plan.reports.slice(index, 1)
    isUpdated.value = true
    close()
    emit('close', isUpdated.value)
    isProcessing.value = false
  }).catch(() => {
  })
}

</script>

<style>
.content {
  overflow: scroll;
  height: 90%;
}

.actions {
  background-color: white;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -20px;
  padding: 5px;
}

.vfm__container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.report-edit-modal {
  width: 780 !important;
  height: 780px !important;
  min-height: 500px !important;
  margin: 49px auto !important;
  position: relative !important;
  background: white;
  border-radius: 4px;
  padding: 20px;
  overflow-y: auto;
}
.modal-overlay {
  position: fixed;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
  opacity: 1;
}

.error-dialog {
  top: 245px;
  left: 752px;
  width: 400px;
  height: auto;
}
.dialog-content {
  width: 100%;
  padding: 15px;
  font-size: 14px;
}
.dialog-c-title {
  font-weight: 600;
  padding-bottom: 15px;
}
.vue-dialog-buttons {
  display: flex;
  width: 100%;
  border-top: 1px solid #eee;
}
.vue-dialog-button {
  font-size: 12px !important;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 40px;
  height: 40px;
  color: inherit;
  font: inherit;
  outline: none;
}

@media (max-width: 1920px) {
  .report-edit-modal {
    height: 80vh;
    width: 780px !important;
    height: 780px !important;
  }

  .report-edit-modal .form-body {
    height: 80vh;
    overflow: scroll;
  }
}

</style>
